import { ACTION_SUBJECT_PREFIX } from '../../constants/analytics';
import { type FireAnalyticsEvent } from '../../types';
import { type CommonAttributes, type NonPrivacySafeAttributes } from './types';

export type CopyLinkButtonClickedArgs = {
	commonAttributes: CommonAttributes;
	nonPrivacySafeAttributes: NonPrivacySafeAttributes;
	location: 'searchResultTitle' | 'searchInput';
};

export const onCopyLinkButtonClicked = ({
	commonAttributes,
	nonPrivacySafeAttributes,
	location,
}: CopyLinkButtonClickedArgs): FireAnalyticsEvent => ({
	eventType: 'ui',
	actionSubject: 'button',
	actionSubjectId: `${ACTION_SUBJECT_PREFIX}CopyLinkButton`,
	action: 'clicked',
	attributes: {
		additionalAttributes: {
			location,
		},
		commonAttributes,
	},
	nonPrivacySafeAttributes,
});
